import React, { useState } from "react";
import {
  MeetingsWrapper,
  MeetingItem,
  AcceptButton,
  MeetingHeading,
  MeetingHead,
  MeetingDescription,
  Meetings,
} from "./style";
import {
  formatDateForMeetingsUnixTimestamp,
  formatTimeRange,
  dateToUnixTimeStamp,
} from "../utils";
import Icon from "../Icon";
import moment from "moment";
import momentTimeZone from "moment-timezone";

const MeetingTable = ({
  eventData,
  acceptMeeting,
  isArchive,
  requestId,
  meetingId,
  acceptMeetingLoader,
}) => {
  const getEasternTimeZoneLabel = () => {
    return "Eastern Time - US & Canada";
  };
  const timeZoneLabel = getEasternTimeZoneLabel();
  const today = new Date();

  const parseTime = (timeStr, dateStr) => {
    return moment(
      `${dateStr} ${timeStr.split("-")[0]}`,
      "dddd, MMMM D, YYYY h:mmA"
    );
  };

  const meetingsData = eventData
    ?.map((meeting) => {
      const unixTimeStamp = Number(meeting?.split("-")[0]);
      const startTime = meeting.split("-")[0];
      const endTime = meeting.split("-")[1];
      const differenceInSeconds = endTime - startTime;
      const differenceInMinutes = differenceInSeconds / 60;

      return {
        unixTimeStamp,
        meetingLength: differenceInMinutes,
        date: formatDateForMeetingsUnixTimestamp(startTime),
        time: `${formatTimeRange(startTime)}-${formatTimeRange(endTime)}`,
        timeZone: timeZoneLabel,
      };
    })
    ?.sort((a, b) => {
      let dateA = moment(a.date, "dddd, MMMM D, YYYY");
      let dateB = moment(b.date, "dddd, MMMM D, YYYY");

      if (!dateA.isSame(dateB)) {
        return dateA.diff(dateB); // ✅ Sort by date first
      }
      return parseTime(a.time, a.date).diff(parseTime(b.time, b.date)); // ✅ Sort by time
    });

  const userTimeZone = momentTimeZone.tz.guess();

  const getReadableTimeZone = (timeZone = userTimeZone) => {
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: timeZone,
      timeZoneName: "long",
    });

    const parts = formatter.formatToParts(new Date());
    const timeZoneName = parts.find((p) => p.type === "timeZoneName")?.value;

    return timeZoneName;
  };

  return (
    <MeetingsWrapper>
      <MeetingHead border={eventData.length <= 0}>Available</MeetingHead>
      <Meetings>
        {meetingsData.map((meeting, index) => {
          return (
            <MeetingItem key={index} id={index}>
              <MeetingHeading>
                {meeting?.meetingLength} Minute Meeting
              </MeetingHeading>
              <MeetingDescription>
                <Icon type={"calendar"} />
                {meeting?.date}
              </MeetingDescription>
              <MeetingDescription>🕒 Time - {meeting?.time}</MeetingDescription>
              {/* <MeetingDescription>🌐 {meeting?.timeZone}</MeetingDescription> */}
              <MeetingDescription>
                🌐 {getReadableTimeZone()}
              </MeetingDescription>
              <AcceptButton
                onClick={() =>
                  acceptMeeting(
                    isArchive ? requestId : meetingId,
                    meeting?.unixTimeStamp
                  )
                }
                disabled={
                  dateToUnixTimeStamp(today) > meeting?.unixTimeStamp ||
                  acceptMeetingLoader
                    ? true
                    : false
                }
              >
                Accept
              </AcceptButton>
            </MeetingItem>
          );
        })}
      </Meetings>
    </MeetingsWrapper>
  );
};

export default MeetingTable;
